export const PAGE_BREAK_CLASSNAME = 'html2pdf__page-break';
export const PAGE_CLASSNAME = 'html2pdf__page';
export const PDF_SCALE_FACTOR = 0.7;

